import React, { useRef, useEffect, useCallback, useState} from 'react';
import MessagingEdge from './MessagingEdge.js';
import {connect} from 'react-redux';

const MessagingEdges = ({
    selectedEdge,
    presentationMode,
    edgesRef,
    subSequence,
    inletConnections,
    containerRef,
    selection
}) => { 
    let isMouseDown = useRef(false);

    useEffect(() => {
        window.addEventListener("mousedown", onMouseDown);
        window.addEventListener("mouseup", onMouseUp);

        return () => {
            window.removeEventListener("mousedown", onMouseDown);
            window.removeEventListener("mouseup", onMouseUp);
        };
    }, []);

    const onMouseDown = () => isMouseDown.current = true;
    const onMouseUp = () => isMouseDown.current = false;

    if (!inletConnections || presentationMode) {
        return [];
    }
    let keys = Object.keys(inletConnections);
    let arr = keys.map(
        inlet =>
        inletConnections[inlet]
            .filter(e =>
                !selectedEdge ||
                    (selectedEdge.outlet !== e ||
                     selectedEdge.inlet !== inlet)
            )
            .flatMap(
                edge =>
                <MessagingEdge
                  edge={edge}
                  edgesRef={edgesRef}
                  key={edge.id}
                  isMouseDown={isMouseDown}
                  subSequence={subSequence}
                  selection={selection}
                  containerRef={containerRef}
                  inlet={inlet}
                  outlet={edge}/>
            ));
    
    if (selectedEdge) {
        let {outlet, inlet} = selectedEdge;
        arr.push(<MessagingEdge
                   edge={outlet}
                   edgesRef={edgesRef}
                   key={selectedEdge.id}
                   isMouseDown={isMouseDown}
                   subSequence={subSequence}
                   selection={selection}
                   containerRef={containerRef}
                   inlet={inlet}
                   outlet={outlet}
                 />);
    }
    return arr;
};

const mapStateToProps = (state, props) => {
    let {selectedEdge} = state.pads;
    return {
        presentationMode: state.spatial.presentationMode,
        selectedEdge,
        inletConnections: state.windows.inletConnections[props.subSequence.id]
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingEdges);
